import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n'; // Import i18n configuration (it initializes on import)
import App from './App.tsx';
import './index.css';

// Render app (i18n initialization happens via import above)
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);